import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'flex flex-col gap-6',
    tabs: 'flex gap-4',
    grid: 'grid grid-cols-1 gap-4 sm:grid-cols-2',
    greeting: 'sm:col-span-2'
  },
  variants: {},
  defaultVariants: {}
});
